function getUrlParams() {
    const params = {}
    
    location.search.replace(
        /([^?&=]+)=([^&]+)/g,
        (_, k, v) => {
            params[k] = v
        }
    )
    
    return params
}

function parseParam( data ) {
    
    if (!data) return ''
    
    let formStr = ''
    for (const [k, v] of Object.entries( data )) {
        formStr += `&${ k }=${ v }`
    }
    return formStr.substr( 1 )
}

function getLang() {
    var langs = ['en', 'pt-pt', 'es', 'zh-hans']
    
    var obj = {
        lang: window.language || 'en',
        index: langs.indexOf(window.language)
    }
    
    obj.index < 0 && ( obj.index = 0 )
    
    return obj
}

export {
    getUrlParams,
    parseParam,
    getLang,
}